module.exports = __webpack_public_path__ + "img/enemy_112_004.fc2c0d76.png";